(function () {
  /* ---- Safe TG fallbacks (بدون import) ---- */
  var TG = (window.themeGlobal && window.themeGlobal) ||
           (window.themeHDN && window.themeHDN.global) || {};

  var $4  = TG.$4  || function(sel, ctx){ return (ctx||document).querySelector(sel); };
  var $$4 = TG.$$4 || function(sel, ctx){ return Array.prototype.slice.call((ctx||document).querySelectorAll(sel)); };

  /* ---- إعدادات الثيم/شوبيفاي (تصحيح shopCurrency/Curency) ---- */
  var themeSettings   = (window.themeHDN && window.themeHDN.settings) || {};
  var shopifyCurrency = (window.Shopify && Shopify.currency) || {};

  var round_currency = !!themeSettings.currencyRound;
  var DEFAULT_CURRENCY = 'OMR';

  // ✅ تصحيح اشتقاق العملة الفعّالة وعملة المتجر
  var cartCurrency = (shopifyCurrency.active ||
                      themeSettings.shopCurrency || themeSettings.shopCurency ||
                      DEFAULT_CURRENCY);

  var shopCurrency = (shopifyCurrency.shop ||
                      themeSettings.shopCurrency || themeSettings.shopCurency ||
                      cartCurrency || DEFAULT_CURRENCY);

  var t_moneyFormat  = themeSettings.currencyFormat || '';
  var dt_cur_shop    = 'currency' + String(cartCurrency).charAt(0) + String(cartCurrency).slice(1).toLowerCase();
  var dt_base        = 'baseCurrency';

  /* === Ready flag helpers === */
  function setReady(val){
    $$4('.hdt-currencies').forEach(function(el){
      el.setAttribute('data-hdt-ready', val ? '1' : '0');
    });
    var root = document.documentElement;
    if (val) { root.classList.remove('currency-wait'); root.classList.add('currency-ready'); }
    else     { root.classList.add('currency-wait');    root.classList.remove('currency-ready'); }
  }

  (function bootHeaderEarly(){
    $$4('.hdt-currencies').forEach(function(el){
      if(!el.hasAttribute('data-hdt-ready')) el.setAttribute('data-hdt-ready','0');
    });

    var saved=null; try{ saved = localStorage.getItem('hdt_currency_iso'); }catch(_){}
    var savedCode = saved ? String(saved).toUpperCase().replace(/[^A-Z]/g,'').slice(0,3) : null;
    if (!savedCode || savedCode === String(shopCurrency).toUpperCase()){
      setReady(1);
    } else {
      setReady(0);
    }
  })();

  /* ---- Minor units ---- */
  var MINOR_UNITS_3 = new Set(['OMR','BHD','JOD','KWD','TND','IQD']);
  function minorUnitsFor(code){ code=String(code||shopCurrency).toUpperCase(); return MINOR_UNITS_3.has(code)?3:2; }
  function factorFor(code){ return Math.pow(10, minorUnitsFor(code)); }

  /* ---- formatMoney ---- */
  function formatMoney(cents, format, code){
    if(!format) format='{{amount}}';
    if(!code) code=shopCurrency;
    var denom = factorFor(code);
    var v = Number(cents)/denom;
    var frac = minorUnitsFor(code);
    var amount = v.toLocaleString(undefined,{minimumFractionDigits:frac,maximumFractionDigits:frac});
    return String(format)
      .replace('{{amount_no_decimals}}', Math.round(v))
      .replace('{{amount_with_comma_separator}}', amount.replace(/\./g, ','))
      .replace('{{amount}}', amount);
  }

  /* ---- ثابتات UI ---- */
  var SELECTOR_CURRENCIES = ".hdt-popover-currencies";

  // ✅ استثناء عناصر الإجمالي من التحويل
  var MONEY_SELECTOR = [
    '.hdt-money:not([data-no-currency-convert])',
    '.money:not(.es-total-placeholder):not(.order-total-money):not(.cart-total-money):not([data-no-currency-convert])',
    '[data-money]:not([data-no-currency-convert])',
    '[data-price]:not([data-no-currency-convert])',
    '.price [class*="money"]:not([data-no-currency-convert])',
    '.product__price [class*="money"]:not([data-no-currency-convert])'
  ].join(',');

  var CRITICAL_SELECTOR = [
    '.product__price [class*="money"]:not([data-no-currency-convert])',
    '.product__price .money:not([data-no-currency-convert])',
    '.price .money:not([data-no-currency-convert])',
    '.price [class*="money"]:not([data-no-currency-convert])',
    '.product-single__price [class*="money"]:not([data-no-currency-convert])',
    '.hdt-price-main [class*="money"]:not([data-no-currency-convert])'
  ].join(',');

  var CURRENT_CURRENCY = null;

  var CurrencyConfigs = {
    currentCurrency: (function(){ try{return localStorage.getItem('hdt_currency_iso')||null;}catch(e){return null;} })(),
    format: themeSettings.currencyCodeEnabled ? 'money_with_currency_format' : 'money_format'
  };

  /* ===== أسعار الصرف: قاعدة OMR، مع نفس احتياط وتحديث التطبيق ===== */
  var RATES = { OMR:1.000, AED:9.555, SAR:9.753, QAR:9.466, BHD:0.978, KWD:0.800, USD:2.601, EUR:2.387, GBP:2.041 };
  var LIVE_RATES_CACHE_KEY = 'bt_live_exchange_rates_omr_v1';
  var LIVE_RATES_TTL = 12 * 60 * 60 * 1000;
  var liveRatesFetchedAt = 0;
  var liveRatesRequest = null;

  function mergeSupportedRates(raw){
    if(!raw || typeof raw !== 'object') return false;
    var updated = false;
    Object.keys(RATES).forEach(function(code){
      var value = Number(raw[code]);
      if(isFinite(value) && value > 0){
        RATES[code] = value;
        updated = true;
      }
    });
    RATES.OMR = 1;
    return updated;
  }

  function hydrateCachedRates(){
    try{
      var cached = JSON.parse(localStorage.getItem(LIVE_RATES_CACHE_KEY) || 'null');
      if(!cached || !cached.rates || !Number(cached.fetchedAt)) return false;
      if(!mergeSupportedRates(cached.rates)) return false;
      liveRatesFetchedAt = Number(cached.fetchedAt);
      return Date.now() - liveRatesFetchedAt < LIVE_RATES_TTL;
    }catch(_){ return false; }
  }

  var hasFreshCachedRates = hydrateCachedRates();

  function getRate(from, to){
    if(!from||!to||from===to) return 1;
    from=String(from).toUpperCase(); to=String(to).toUpperCase();
    var rFrom = RATES[from] ? Number(RATES[from]) : null;
    var rTo   = RATES[to] ? Number(RATES[to]) : null;
    if(rFrom==null||rTo==null) return 1;
    return rTo/rFrom;
  }

  function convertCents(centsFrom, from, to){
    var denomFrom=factorFor(from), denomTo=factorFor(to);
    var majorFrom=Number(centsFrom)/denomFrom;
    var majorTo  =majorFrom*getRate(from,to);
    return Math.round(majorTo*denomTo);
  }

  function getMoneyFormat(code, format){
    return (moneyFormats[code] && moneyFormats[code][format||CurrencyConfigs.format]) || '{{amount}}';
  }

  function normalizeCurrencyCode(code){
    var raw=String(code||'').split('|')[0].trim().toUpperCase();
    var iso=raw.replace(/[^A-Z]/g,'').slice(0,3);
    return iso||raw;
  }

  /* ---- جدول دول -> عملات ---- */
  var arrayCurrency = {
    AF:"AFN",AX:"EUR",AL:"ALL",DZ:"DZD",AS:"USD",AD:"EUR",AO:"AOA",AI:"XCD",AQ:"XCD",AG:"XCD",
    AR:"ARS",AM:"AMD",AW:"AWG",AU:"AUD",AT:"EUR",AZ:"AZN",BS:"BSD",BH:"BHD",BD:"BDT",BB:"BBD",
    BY:"BYN",BE:"EUR",BZ:"BZD",BJ:"XOF",BM:"BMD",BT:"BTN",BO:"BOB",BA:"BAM",BW:"BWP",BV:"NOK",
    BR:"BRL",IO:"USD",BN:"BND",BG:"BGN",BF:"XOF",BI:"BIF",KH:"KHR",CM:"XAF",CA:"CAD",CV:"CVE",
    KY:"KYD",CF:"XAF",TD:"XAF",CL:"CLP",CN:"CNY",CX:"AUD",CC:"AUD",CO:"COP",KM:"KMF",CG:"XAF",
    CD:"CDF",CK:"NZD",CR:"CRC",CI:"XOF",HR:"HRK",CU:"CUP",CY:"EUR",CZ:"CZK",DK:"DKK",DJ:"DJF",
    DM:"XCD",DO:"DOP",EC:"USD",EG:"EGP",SV:"USD",GQ:"XAF",ER:"ERN",EE:"EUR",ET:"ETB",FK:"FKP",
    FO:"DKK",FJ:"FJD",FI:"EUR",FR:"EUR",GF:"EUR",PF:"XPF",TF:"EUR",GA:"XAF",GM:"GMD",GE:"GEL",
    DE:"EUR",GH:"GHS",GI:"GIP",GR:"EUR",GL:"DKK",GD:"XCD",GP:"EUR",GU:"USD",GT:"GTQ",GG:"GBP",
    GN:"GNF",GW:"XOF",GY:"GYD",HT:"HTG",HM:"AUD",VA:"EUR",HN:"HNL",HK:"HKD",HU:"HUF",IS:"ISK",
    IN:"INR",ID:"IDR",IR:"IRR",IQ:"IQD",IE:"EUR",IM:"GBP",IL:"ILS",IT:"EUR",JM:"JMD",JP:"JPY",
    JE:"GBP",JO:"JOD",KZ:"KZT",KE:"KES",KI:"AUD",KR:"KRW",KW:"KWD",KG:"KGS",LA:"LAK",LV:"EUR",
    LB:"LBP",LS:"LSL",LR:"LRD",LY:"LYD",LI:"CHF",LT:"EUR",LU:"EUR",MO:"MOP",MK:"MKD",MG:"MGA",
    MW:"MWK",MY:"MYR",MV:"MVR",ML:"XOF",MT:"EUR",MH:"USD",MQ:"EUR",MR:"MRU",MU:"MUR",YT:"EUR",
    MX:"MXN",FM:"USD",MD:"MDL",MC:"EUR",MN:"MNT",ME:"EUR",MS:"XCD",MA:"MAD",MZ:"MZN",MM:"MMK",
    NA:"NAD",NR:"AUD",NP:"NPR",NL:"EUR",AN:"",NC:"XPF",NZ:"NZD",NI:"NIO",NE:"XOF",NG:"NGN",
    NU:"NZD",NF:"AUD",MP:"USD",NO:"NOK",OM:"OMR",PK:"PKR",PW:"USD",PS:"ILS",PA:"PAB",PG:"PGK",
    PY:"PYG",PE:"PEN",PH:"PHP",PN:"NZD",PL:"PLN",PT:"EUR",PR:"USD",QA:"QAR",RE:"EUR",RO:"RON",
    RU:"RUB",RW:"RWF",BL:"EUR",SH:"SHP",KN:"XCD",LC:"XCD",MF:"EUR",PM:"EUR",VC:"XCD",WS:"WST",
    SM:"EUR",ST:"STN",SA:"SAR",SN:"XOF",RS:"RSD",SC:"SCR",SL:"SLL",SG:"SGD",SK:"EUR",SI:"EUR",
    SB:"SBD",SO:"SOS",ZA:"ZAR",GS:"GBP",ES:"EUR",LK:"LKR",SD:"SDG",SR:"SRD",SJ:"NOK",SZ:"SZL",
    SE:"SEK",CH:"CHF",SY:"SYP",TW:"TWD",TJ:"TJS",TZ:"TZS",TH:"THB",TL:"USD",TG:"XOF",TK:"NZD",
    TO:"TOP",TT:"TTD",TN:"TND",TR:"TRY",TM:"TMT",TC:"USD",TV:"AUD",UG:"UGX",UA:"UAH",AE:"AED",
    GB:"GBP",US:"USD",UM:"USD",UY:"UYU",UZ:"UZS",VU:"VUV",VE:"VEF",VN:"VND",VG:"USD",VI:"USD",
    WF:"XPF",EH:"MAD",YE:"YER",ZM:"ZMW",ZW:"ZWD"
  };

  /* ---- moneyFormats ---- */
  var moneyFormats = {
    "USD":{"money_format":"${{amount}}","money_with_currency_format":"${{amount}} USD"},
    "EUR":{"money_format":"&euro;{{amount}}","money_with_currency_format":"&euro;{{amount}} EUR"},
    "GBP":{"money_format":"&pound;{{amount}}","money_with_currency_format":"&pound;{{amount}} GBP"},
    "AED":{"money_format":"Dhs. {{amount}}","money_with_currency_format":"AED {{amount}}"},
    "SAR":{"money_format":"{{amount}} SR","money_with_currency_format":"{{amount}} SAR"},
    "QAR":{"money_format":"QAR {{amount_with_comma_separator}}","money_with_currency_format":"QAR {{amount_with_comma_separator}}"},
    "KWD":{"money_format":"{{amount}} KD","money_with_currency_format":"{{amount}} KWD"},
    "BHD":{"money_format":"{{amount}} BD","money_with_currency_format":"{{amount}} BHD"},
    "OMR":{"money_format":"{{amount_with_comma_separator}} OMR","money_with_currency_format":"{{amount_with_comma_separator}} OMR"}
  };

  /* ---- Parsing أرقام عربية/فواصل ---- */
  var ARABIC_DIGITS_RX = /[٠-٩۰-۹]/g;
  var ARABIC_DIGIT_MAP = {'٠':'0','١':'1','٢':'2','٣':'3','٤':'4','٥':'5','٦':'6','٧':'7','٨':'8','٩':'9','۰':'0','۱':'1','۲':'2','۳':'3','۴':'4','۵':'5','۶':'6','۷':'7','۸':'8','۹':'9'};
  function normalizeDigits(str){ return String(str).replace(ARABIC_DIGITS_RX,function(d){return ARABIC_DIGIT_MAP[d]||d;}); }

  function parseMoneyText(txt){
    var s = normalizeDigits(String(txt||'').trim());
    var commaCount=(s.match(/,/g)||[]).length, dotCount=(s.match(/\./g)||[]).length;
    if(commaCount>0 && dotCount===0){ s=s.replace(',', '.'); }
    s=s.replace(/^[^0-9\-]+|[^0-9.\-]/g,'');
    var v=parseFloat(s);
    return isFinite(v)?v:NaN;
  }

  /* ===== علّم عناصر الإجمالي حتى لا تتحول ===== */
  function markTotalElements() {
    var selectors = [
      '.es-total-placeholder.money',
      '.total-value .money',
      '.total-value > .money',
      '.order-summary .money',
      '.cart-total .money',
      '.cart-totals .money'
    ].join(',');

    $$4(selectors).forEach(function(el) {
      var rowText = ((el.parentElement && el.parentElement.textContent) || '').trim();
      var selfText = (el.textContent || '').trim();

      if (
        el.matches('.es-total-placeholder.money') ||
        /المجموع|المجموع الفرعي|الشحن|discount|coupon|خصم|subtotal|shipping|total/i.test(rowText) ||
        /المجموع|discount|coupon|خصم|subtotal|shipping|total/i.test(selfText)
      ) {
        el.setAttribute('data-no-currency-convert', '1');
      }
    });
  }

  /* ===== التقاط قيمة الأساس بعملة المتجر ===== */
  function baseCurrency(el, format){
    var newFormat = getMoneyFormat(shopCurrency, format);
    var baseAmount = el.getAttribute('data-base-money') || el.textContent || '';
    if((t_moneyFormat||'').indexOf('with_comma_separator')!==-1){
      baseAmount = baseAmount.replace(/[,.]/g, function(m){ return (m===',') ? '.' : ','; });
    }
    var denomShop=factorFor(shopCurrency);
    var parsed = parseMoneyText(baseAmount);
    var cents = parsed*denomShop;
    if(!isFinite(cents)) return;
    el.dataset[dt_base]=cents;
    el.setAttribute("data-currency-"+shopCurrency.toLowerCase(), formatMoney(cents, newFormat, shopCurrency));
    return cents;
  }

  /* ===== التحويل العام ===== */
  function CurrencyConvertAll(newCurrency, selectorArg, format){
    if(!newCurrency) return false;
    markTotalElements();

    var target = normalizeCurrencyCode(newCurrency);
    var list = Array.isArray(selectorArg) ? selectorArg : $$4(selectorArg || (MONEY_SELECTOR+':not([no-select-money],[data-hdt-currency="'+target+'"])'));
    var newFormat = getMoneyFormat(target, format);

    list.forEach(function(el){
      if (el.hasAttribute('data-no-currency-convert')) return;

      if(!el.dataset[dt_cur_shop]) el.dataset[dt_cur_shop]=el.textContent;
      var baseAmount = el.dataset[dt_base] ? parseFloat(el.dataset[dt_base]) : baseCurrency(el, format);
      if(!isFinite(baseAmount)) return;

      var dataKey = 'currency'+target.charAt(0)+target.slice(1).toLowerCase();
      if(el.dataset[dataKey]){
        el.innerHTML = el.dataset[dataKey];
      }else{
        var newCents = convertCents(baseAmount, shopCurrency, target);
        if(round_currency){
          var denom=factorFor(target);
          newCents = Math.round(newCents/denom)*denom;
        }
        var newFormattedAmount = formatMoney(newCents, newFormat, target);
        el.innerHTML = newFormattedAmount;
        el.dataset[dataKey] = newFormattedAmount;
      }
      el.dataset.hdtCurrency = target;
    });

    $$4('.selected-currency').forEach(function(el){ el.textContent=target; });
    try{ localStorage.setItem('hdt_currency_iso', target); localStorage.setItem('T4Currency', target); }catch(e){}
    document.dispatchEvent(new CustomEvent('currency:applied',{detail:{currency:target}}));
  }

  /* ===== اختيار محفوظ ===== */
  function getSavedCurrencyISO(){
    try{
      var a=localStorage.getItem('hdt_currency_iso');
      var b=localStorage.getItem('T4Currency');
      var val=a||b; if(!val||val==='null') return null;
      var raw=String(val).split('|')[0].trim().toUpperCase();
      var iso=raw.replace(/[^A-Z]/g,'').slice(0,3);
      return iso||raw;
    }catch(e){ return null; }
  }

  /* ===== تحديث العلم/الاسم بسرعة ===== */
  function refreshCurrentFlagAndName(currentCode){
    currentCode = String(currentCode||'').toUpperCase().split('|')[0].replace(/[^A-Z]/g,'').slice(0,3);
    $$4('[data-flag-current]').forEach(function (el) { setFlagImg(el, currentCode); });
    $$4('[data-name-current]').forEach(function (el) { el.textContent = currentCode; });
  }

  /* ========= Currency → Country helpers (for flags) ========= */
  var currencyToCountry = (function(){
    var map = {};
    for (var cc in arrayCurrency) {
      if (!arrayCurrency.hasOwnProperty(cc)) continue;
      var cur = String(arrayCurrency[cc] || '').toUpperCase();
      if (!cur) continue;
      map[cur] = String(cc).toUpperCase();
    }
    var overrides = {
      USD:'US', EUR:'EU', GBP:'GB',
      AED:'AE', SAR:'SA', QAR:'QA', KWD:'KW', BHD:'BH', OMR:'OM',
      INR:'IN', JOD:'JO', TND:'TN', IQD:'IQ', CHF:'CH', CAD:'CA', AUD:'AU', NZD:'NZ', JPY:'JP', CNY:'CN'
    };
    for (var k in overrides) map[k] = overrides[k];
    return map;
  })();

  function currencyCodeToFlagISO(code){
    code = String(code||'').toUpperCase().split('|')[0].replace(/[^A-Z]/g,'').slice(0,3);
    var cc = currencyToCountry[code];
    if (!cc) { cc = code.slice(0,2); }
    return cc || 'US';
  }

  function setFlagImg(imgEl, currencyCode){
    try{
      var iso2 = currencyCodeToFlagISO(currencyCode).toLowerCase();
      imgEl.setAttribute('src', '//cdn.shopify.com/static/images/flags/'+iso2+'.svg');
      imgEl.setAttribute('srcset', '//cdn.shopify.com/static/images/flags/'+iso2+'.svg?width=32 32w');
      imgEl.setAttribute('alt', currencyCode);
    }catch(_){}
  }

  function refreshFlagsInList(){
    $$4(SELECTOR_CURRENCIES).forEach(function (wrap) {
      $$4('button[value], [role="option"][value], [data-value]', wrap).forEach(function (el) {
        var v = (el.getAttribute('value') || el.getAttribute('data-value') || '').toUpperCase();
        if (!v) return;
        var iso = v.split('|')[0].replace(/[^A-Z]/g,'').slice(0,3);
        var img = el.querySelector('img');
        if (img) setFlagImg(img, iso);
      });
      var auto = wrap.querySelector('.hdt-item-auto');
      if (auto) {
        var code = (auto.getAttribute('value') || auto.getAttribute('data-name') || '').toUpperCase();
        var img = auto.querySelector('img');
        if (img && code) setFlagImg(img, code);
      }
    });
  }

  /* ===== منع تكرار عملة المتجر في القائمة ===== */
  function dedupeCurrencyListUI(){
    $$4(SELECTOR_CURRENCIES).forEach(function (wrap) {
      var auto = wrap.querySelector('.hdt-item-auto');
      if (auto) {
        var autoVal = (auto.getAttribute('value') || auto.getAttribute('data-name') || '').toUpperCase().split('|')[0].replace(/[^A-Z]/g,'').slice(0,3);
        var hasSame = !!Array.from(wrap.querySelectorAll('button[value], [role="option"][value], [data-value]')).find(function (el) {
          var v = (el.getAttribute('value') || el.getAttribute('data-value') || '').toUpperCase();
          v = v.split('|')[0].replace(/[^A-Z]/g,'').slice(0,3);
          return v === autoVal;
        });
        if (hasSame) { auto.parentNode && auto.parentNode.removeChild(auto); }
      }
      var sel = wrap.querySelector('select');
      if (sel) {
        var seen = new Set();
        Array.from(sel.querySelectorAll('option[value]')).forEach(function (opt) {
          var v = (opt.getAttribute('value') || '').toUpperCase();
          v = v.split('|')[0].replace(/[^A-Z]/g,'').slice(0,3);
          if (!v) return;
          if (seen.has(v)) { opt.parentNode && opt.parentNode.removeChild(opt); }
          else { seen.add(v); }
        });
      }
    });
  }

  /* ===== اجمع قائمة Supported currencies من واجهة القالب ===== */
  function getSupportedCurrenciesFromUI(){
    var set = new Set();
    Object.keys(RATES).forEach(function(code){
      code = String(code || '').toUpperCase();
      if(code && moneyFormats[code]) set.add(code);
    });
    set.add(DEFAULT_CURRENCY);
    return set;
  }

  /* ===== تحويل حرِج سريع ===== */
  function preApplyCriticalSaved(){
    try{
      var saved = getSavedCurrencyISO && getSavedCurrencyISO();
      if(!saved) return false;
      var s3 = String(saved).toUpperCase().replace(/[^A-Z]/g,'').slice(0,3);
      if(!s3 || s3 === String(shopCurrency).toUpperCase()) return false;

      markTotalElements();
      CurrencyConvertAll(s3, CRITICAL_SELECTOR);

      setReady(1);
      return true;
    }catch(_){ return false; }
  }

  /* ===== بدّل عملة ===== */
  function applyCurrency(code){
    code = normalizeCurrencyCode(code);
    if(!getSupportedCurrenciesFromUI().has(code)) code = DEFAULT_CURRENCY;
    CURRENT_CURRENCY = code;
    try{ localStorage.setItem('hdt_currency_iso', code); localStorage.setItem('T4Currency', code); }catch(_){}
    var rl = $4(SELECTOR_CURRENCIES+' hdt-richlist'); if(rl) rl.setAttribute('selected', code);

    $$4(SELECTOR_CURRENCIES).forEach(function(wrap){
      var auto = wrap.querySelector('.hdt-item-auto');
      if (auto) {
        auto.setAttribute('value', code);
        auto.setAttribute('data-name', code);
        var img = auto.querySelector('img');
        if (img) setFlagImg(img, code);
        var sp = auto.querySelector('span'); if (sp) sp.textContent = code;
        auto.classList.remove('wait');
      }
    });

    refreshCurrentFlagAndName(code);
    markTotalElements();
    CurrencyConvertAll(code);
    dedupeCurrencyListUI();
    refreshFlagsInList();
    setReady(1);
    if(code !== DEFAULT_CURRENCY) scheduleLiveRates(true);
  }

  function applySavedCurrency(force){
    var saved=getSavedCurrencyISO(); if(!saved) return false;
    if(!getSupportedCurrenciesFromUI().has(saved)) saved=DEFAULT_CURRENCY;
    if(!force && saved===(CURRENT_CURRENCY||'').toUpperCase()) return true;
    CURRENT_CURRENCY=saved;
    try{ localStorage.setItem('hdt_currency_iso', saved); localStorage.setItem('T4Currency', saved); }catch(e){}
    var rl = $4(SELECTOR_CURRENCIES+' hdt-richlist'); if(rl) rl.setAttribute('selected', saved);
    markTotalElements();
    CurrencyConvertAll(saved);
    refreshCurrentFlagAndName(saved);
    dedupeCurrencyListUI();
    refreshFlagsInList();
    setReady(1);
    return true;
  }

  /* ===== Geo ===== */
  function buildFromData(data){
    var country = String((data && data.country) || '').toUpperCase();
    var ipCurrency = arrayCurrency[country] || DEFAULT_CURRENCY;
    var supported = getSupportedCurrenciesFromUI();

    var saved = getSavedCurrencyISO();
    var previousCountry = '';
    try{
      var previousGeo = JSON.parse(localStorage.getItem('hdt_currency') || 'null') || {};
      previousCountry = String(previousGeo.country || '').toUpperCase();
    }catch(_){ previousCountry = ''; }
    // Preserve a manual choice while the IP country is unchanged. If the
    // visitor moves to another country, refresh the currency automatically.
    if(saved && previousCountry && previousCountry === country){
      if(supported.has(saved)) return;
      applyCurrency(DEFAULT_CURRENCY);
      return;
    }

    if(supported.has(ipCurrency)){
      applyCurrency(ipCurrency);
    }else{
      applyCurrency(DEFAULT_CURRENCY);
    }
  }

  function rememberGeoCountry(country){
    var normalizedCountry = String(country || '').toUpperCase();
    try{ localStorage.setItem('hdt_currency', JSON.stringify({country:normalizedCountry})); }catch(e){}
    try{
      sessionStorage.setItem('bt.geo.current.v1', JSON.stringify({
        country: normalizedCountry,
        detectedAt: Date.now()
      }));
    }catch(e){}
    document.dispatchEvent(new CustomEvent('bt:geo:updated', { detail: { country: normalizedCountry } }));
  }

  function applySafeGeoFallback(){
    var saved = getSavedCurrencyISO();
    var supported = getSupportedCurrenciesFromUI();
    if(saved && supported.has(saved)){
      applySavedCurrency(true);
      return;
    }
    applyCurrency(DEFAULT_CURRENCY);
  }

  function fetchIpinfo(){
    return fetch('https://ipinfo.io/json',{method:'GET',cache:'no-store'})
      .then(function(res){ if(!res.ok) throw new Error('IP lookup failed'); return res.json(); })
      .then(function(data){
        var cc = String((data && data.country) || '').toUpperCase();
        if(!cc) throw new Error('IP country missing');
        buildFromData({country: cc});
        rememberGeoCountry(cc);
      })
      .catch(function(e){ console.error('Error ipinfo:', e); applySafeGeoFallback(); });
  }

  function fetchShopifyGeo(){
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root + 'browsing_context_suggestions.json?country[enabled]=true', {
      method: 'GET',
      cache: 'no-store',
      credentials: 'same-origin'
    })
      .then(function(res){ if(!res.ok) throw new Error('Shopify geo lookup failed'); return res.json(); })
      .then(function(data){
        var detected = data && data.detected_values && data.detected_values.country;
        var cc = String((detected && detected.handle) || '').toUpperCase();
        if(!cc) throw new Error('Shopify country missing');
        buildFromData({country: cc});
        rememberGeoCountry(cc);
      })
      .catch(function(){ return fetchIpinfo(); });
  }

  var geoDetectionScheduled = false;
  function scheduleGeoCurrencyDetection(){
    if(geoDetectionScheduled) return;
    geoDetectionScheduled = true;
    // Use the same direct IP lookup as the COD visibility gate. Do not skip it
    // merely because an older currency is stored in localStorage.
    fetchShopifyGeo();
  }

  /* ===== Init ===== */
  function init(){
    markTotalElements();

    preApplyCriticalSaved();

    var applied = applySavedCurrency(false);

    if(!$4(SELECTOR_CURRENCIES)){
      if(!applied){ applyCurrency(shopCurrency); }
      return;
    }

    if(applied){
      var w = $4(SELECTOR_CURRENCIES+' .hdt-item-auto.wait');
      if(w){ w.classList.remove('wait'); w.parentNode && w.parentNode.removeChild(w); }
      dedupeCurrencyListUI();
      refreshFlagsInList();
      markTotalElements();
      scheduleGeoCurrencyDetection();
      return;
    }

    if(!themeSettings.autoCurrencies || /bot|spider/i.test(navigator.userAgent)){
      applyCurrency(shopCurrency);
      var w2 = $4(SELECTOR_CURRENCIES+' .hdt-item-auto.wait');
      if(w2){ w2.classList.remove('wait'); w2.parentNode && w2.parentNode.removeChild(w2); }
      dedupeCurrencyListUI();
      refreshFlagsInList();
      markTotalElements();
      return;
    }

    var nt=null; try{ nt=localStorage.getItem('hdt_currency'); }catch(e){}
    if(nt){
      try{
        var obj=JSON.parse(nt)||{};
        var cc=String(obj.country||'').toUpperCase();
        buildFromData({country:cc});
      }catch(e){}
    }
    scheduleGeoCurrencyDetection();

    dedupeCurrencyListUI();
    refreshFlagsInList();
    markTotalElements();
  }

  /* ===== Events ===== */
  document.addEventListener("richlist:change", function(e){
    if(e.target && e.target.name==="country_code" && e.detail && e.detail.value){
      applyCurrency(e.detail.value);
    }
  });

  document.addEventListener('click', function(ev){
    var btn = ev.target && ev.target.closest ? ev.target.closest(SELECTOR_CURRENCIES+' [value]') : null;
    if(!btn) return;
    applyCurrency(btn.getAttribute('value'));
  });

  document.addEventListener('change', function(ev){
    var sel = ev.target && ev.target.closest ? ev.target.closest(SELECTOR_CURRENCIES+' select') : null;
    if(!sel) return;
    applyCurrency(sel.value);
  });

  function refreshConvertedPrices(){
    markTotalElements();
    applySavedCurrency(true) || applyCurrency(shopCurrency);
  }

  function clearConvertedCurrencyCache(){
    $$4(MONEY_SELECTOR).forEach(function(el){
      Object.keys(RATES).forEach(function(code){
        if(code === String(shopCurrency).toUpperCase()) return;
        var key = 'currency'+code.charAt(0)+code.slice(1).toLowerCase();
        try{ delete el.dataset[key]; }catch(_){}
      });
    });
  }

  function fetchLiveRates(){
    if(hasFreshCachedRates || (liveRatesFetchedAt && Date.now() - liveRatesFetchedAt < LIVE_RATES_TTL)){
      return Promise.resolve(false);
    }
    if(liveRatesRequest) return liveRatesRequest;

    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timeout = window.setTimeout(function(){ if(controller) controller.abort(); }, 6000);
    liveRatesRequest = fetch('https://open.er-api.com/v6/latest/OMR', {
      method: 'GET',
      cache: 'no-store',
      signal: controller ? controller.signal : undefined
    })
      .then(function(response){
        if(!response.ok) throw new Error('Exchange rate request failed');
        return response.json();
      })
      .then(function(data){
        if(!data || data.result !== 'success' || !mergeSupportedRates(data.rates)) return false;
        liveRatesFetchedAt = Date.now();
        hasFreshCachedRates = true;
        try{
          localStorage.setItem(LIVE_RATES_CACHE_KEY, JSON.stringify({
            fetchedAt: liveRatesFetchedAt,
            rates: RATES
          }));
        }catch(_){}
        clearConvertedCurrencyCache();
        refreshConvertedPrices();
        document.dispatchEvent(new CustomEvent('currency:rates-updated', {
          detail: { base: 'OMR', fetchedAt: liveRatesFetchedAt }
        }));
        return true;
      })
      .catch(function(){ return false; })
      .finally(function(){
        window.clearTimeout(timeout);
        liveRatesRequest = null;
      });
    return liveRatesRequest;
  }

  function scheduleLiveRates(force){
    if(hasFreshCachedRates) return;
    var activeCurrency = String(CURRENT_CURRENCY || getSavedCurrencyISO() || shopCurrency || DEFAULT_CURRENCY).toUpperCase();
    if(!force && activeCurrency === DEFAULT_CURRENCY) return;
    var queueLiveRates = function(){
      if(hasFreshCachedRates) return;
      if(typeof window.requestIdleCallback === 'function'){
        window.requestIdleCallback(fetchLiveRates, { timeout: 5000 });
      }else{
        window.setTimeout(fetchLiveRates, 2500);
      }
    };
    if(document.readyState === 'complete'){
      queueLiveRates();
    }else{
      window.addEventListener('load', queueLiveRates, { once: true });
    }
  }

  [
    'currency:update',
    'products:update',
    'cart:update',
    'cart:reload',
    'cart:drawer:render',
    'cart:main:render',
    'quick-view:loaded'
  ].forEach(function(eventName){
    document.addEventListener(eventName, refreshConvertedPrices);
  });

  document.addEventListener('shopify:section:load',   function(){ markTotalElements(); applySavedCurrency(true) || applyCurrency(shopCurrency); });
  document.addEventListener('shopify:section:reorder',function(){ markTotalElements(); applySavedCurrency(true) || applyCurrency(shopCurrency); });

  var lazy = $4('hdt-lazy-html[section-id="popover-currencies"]');
  if(lazy){
    lazy.addEventListener('lazyhtml:added', function(){
      init();
      applySavedCurrency(true);
      dedupeCurrencyListUI();
      refreshFlagsInList();
      markTotalElements();
    });
  }

  setTimeout(function(){ setReady(1); }, 1200);

  window.CurrencyConvertAll = CurrencyConvertAll;
  window.CurrencySet = function(code){ applyCurrency(code); };

  init();
  scheduleLiveRates();
})();
